import { render, staticRenderFns } from "./SalesByCategory.vue?vue&type=template&id=6db9cadc&scoped=true"
import script from "./SalesByCategory.vue?vue&type=script&lang=js"
export * from "./SalesByCategory.vue?vue&type=script&lang=js"
import style0 from "./SalesByCategory.vue?vue&type=style&index=0&id=6db9cadc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db9cadc",
  null
  
)

export default component.exports